import React from 'react';
const comparisonRows = [{
  situation: 'Tu cursada',
  without: 'Materias sueltas sin conexión',
  with: 'Todo ordenado por etapa y materia'
}, {
  situation: 'Parciales',
  without: 'Estudiás de cero cada vez',
  with: 'Resúmenes y esquemas listos'
}, {
  situation: 'Finales',
  without: 'Sin saber por dónde empezar',
  with: 'Banco de preguntas por materia'
}, {
  situation: 'Finales orales',
  without: 'Te bloqueás frente al docente',
  with: 'Script de respuesta y vocabulario técnico'
}, {
  situation: 'Bibliografía',
  without: 'Horas perdidas en fotocopias',
  with: 'Síntesis organizada lista para usar'
}, {
  situation: 'Cuando te recibís',
  without: 'Sin saber cómo arrancar',
  with: 'Sistema listo para tu consultorio'
}, {
  situation: 'Cobro profesional',
  without: 'Sin política clara',
  with: 'Contrato + arancel listos'
}, {
  situation: 'Tu identidad profesional',
  without: 'Sin estrategia ni contenido',
  with: '30 días de contenido listo'
}];
const blocks = [{
  num: '01',
  emoji: '💼',
  title: 'Tu Primer Consultorio Psicológico',
  desc: 'Todo lo que necesitás para arrancar: contrato, consentimiento informado y política de cobro.'
}, {
  num: '02',
  emoji: '💰',
  title: 'Cobro Profesional Blindado',
  desc: 'Sistema de abono mensual adelantado + planilla de pagos + calculadora de honorarios psicológicos.'
}, {
  num: '03',
  emoji: '📋',
  title: 'Historia Clínica en 5 Minutos',
  desc: 'Frases clínicas copy/paste. Registro de evolución psicológica listo para usar desde el día uno.'
}, {
  num: '04',
  emoji: '📱',
  title: 'Presencia Digital Lista',
  desc: '20 tipos de post + calendario de 30 días + 20 stories listos para publicar como psicólogo/a.'
}];
const assets = ['Planilla de Pagos', 'Calculadora de Honorarios', 'Reglamento Interno', 'Contrato de Servicios', 'Consentimiento Informado', 'Autorización de Imagen', '20 Stories Listos'];
export function ProBusiness() {
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-10" style={{
    background: 'linear-gradient(180deg, #FDF4E7 0%, #FEFAF4 50%, #FEFAF4 100%)'
  }} data-id="element-255">
      <div className="mx-auto max-w-4xl" data-id="element-256">

        {/* Header */}
        <h2 className="text-3xl font-black text-center m-0 mb-2" style={{
        color: '#1E1208'
      }} data-id="element-257">
          ¿Qué agrega{' '}
          <span style={{
          color: '#C8922A'
        }} data-id="element-258">Máster Psicología™?</span>
        </h2>
        <p className="text-center text-sm mx-auto max-w-xl m-0 mb-8" style={{
        color: '#9A7B5A'
      }} data-id="element-259">
          El sistema completo para que cuando te recibas, no arranques de cero.
          Tu consultorio, tu cobro y tu identidad profesional, listos.
        </p>

        {/* Scroll hint mobile */}
        <p className="text-xs text-center mb-2 sm:hidden flex items-center justify-center gap-1" style={{
        color: '#9A7B5A'
      }} data-id="element-260">
          <span data-id="element-261">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* Comparison Table */}
        <div className="mb-8 overflow-x-auto rounded-xl shadow-sm touch-pan-x" style={{
        border: '1px solid rgba(200,146,42,0.22)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-262">
          <div className="min-w-[560px] rounded-xl overflow-hidden" style={{
          backgroundColor: 'rgba(255,255,255,0.97)'
        }} data-id="element-263">
            {/* Table Header */}
            <div className="grid grid-cols-3" style={{
            borderBottom: '1px solid rgba(200,146,42,0.12)'
          }} data-id="element-264">
              <div className="px-4 py-3 text-xs font-bold uppercase tracking-wide" style={{
              color: '#9A7B5A'
            }} data-id="element-265">
                Situación
              </div>
              <div className="px-4 py-3 text-xs font-bold uppercase tracking-wide text-center" style={{
              color: '#9A7B5A',
              borderLeft: '1px solid rgba(200,146,42,0.12)'
            }} data-id="element-266">
                ❌ Sin Máster Psicología
              </div>
              <div className="px-4 py-3 text-xs font-bold uppercase tracking-wide text-center" style={{
              color: '#C8922A',
              borderLeft: '1px solid rgba(200,146,42,0.12)'
            }} data-id="element-267">
                ✅ Con Máster Psicología
              </div>
            </div>

            {/* Table Rows */}
            {comparisonRows.map((row, i) => <div key={row.situation} className="grid grid-cols-3" style={{
            borderBottom: i < comparisonRows.length - 1 ? '1px solid rgba(200,146,42,0.08)' : undefined
          }} data-id="element-268">
                <div className="px-4 py-3 text-xs font-bold" style={{
              color: '#1E1208'
            }} data-id="element-269">
                  {row.situation}
                </div>
                <div className="px-4 py-3 text-xs text-center" style={{
              color: '#9A7B5A',
              borderLeft: '1px solid rgba(200,146,42,0.08)',
              backgroundColor: 'rgba(200,146,42,0.03)'
            }} data-id="element-270">
                  {row.without}
                </div>
                <div className="px-4 py-3 text-xs text-center" style={{
              color: '#1E1208',
              borderLeft: '1px solid rgba(200,146,42,0.08)',
              backgroundColor: 'rgba(122,158,126,0.06)'
            }} data-id="element-271">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Blocks */}
        <div className="rounded-xl overflow-hidden shadow-sm mb-4" style={{
        border: '1px solid rgba(200,146,42,0.22)'
      }} data-id="element-272">
          {/* Header */}
          <div className="px-5 py-3" style={{
          background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 50%, #7A9E7E 100%)'
        }} data-id="element-273">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-274">
              🏆 MÁSTER PSICOLOGÍA™ INCLUYE:
            </h3>
          </div>

          <div className="divide-y" style={{
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: 'rgba(200,146,42,0.10)'
        }} data-id="element-275">
            {blocks.map(block => <div key={block.num} className="flex items-center gap-4 px-5 py-3" style={{
            borderColor: 'rgba(200,146,42,0.10)'
          }} data-id="element-276">
                <span className="shrink-0 text-lg font-black w-8 text-center" style={{
              color: 'rgba(200,146,42,0.35)'
            }} data-id="element-277">
                  {block.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-278">
                  <span className="block text-sm font-black" style={{
                color: '#1E1208'
              }} data-id="element-279">
                    {block.emoji} {block.title}
                  </span>
                  <span className="block text-xs mt-0.5" style={{
                color: '#9A7B5A'
              }} data-id="element-280">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Assets */}
        <div className="rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgba(122,158,126,0.07)',
        border: '1px solid rgba(122,158,126,0.22)'
      }} data-id="element-281">
          <p className="text-xs font-bold uppercase tracking-widest m-0 mb-3" style={{
          color: '#7A9E7E'
        }} data-id="element-282">
            📊 Assets incluidos:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-283">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold rounded-full px-3 py-1" style={{
            color: '#7A9E7E',
            backgroundColor: 'rgba(255,255,255,0.92)',
            border: '1px solid rgba(122,158,126,0.25)'
          }} data-id="element-284">
                {asset}
              </span>)}
          </div>
        </div>
      </div>

      {/* Degradé inferior → conecta con Guarantee */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FEFAF4 100%)'
    }} data-id="element-285" />
    </section>;
}